<template>
  <div class="main">
    <webheader></webheader>
    <div class="products-content flex-top flex-column">
      <div class="carousel">
        <el-carousel :interval="4000"
                     @change="changeProduct"
                     indicator-position='none'
                     arrow='never'
                     type="card"
                     height="444px">
          <el-carousel-item v-for="(item,index) in products"
                            :key="index">
            <img :src="item.imgUrl"
                 alt=""
                 height="444px"
                 width="888px">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="product-info  ">
        <div class="product-title"></div>
        <div class="product-other-info">
          <p>影片类型： {{productInfo.type}}</p>
          <p>正片片长： {{productInfo.times}}</p>
        </div>
        <div class="product-desc ">
          {{productInfo.desc}}
        </div>
      </div>
    </div>
    <tabfooter></tabfooter>
  </div>
</template>

<script>
import webheader from '@/components/webheader'
import tabfooter from '@/components/tabfooter'
export default {
  components: { tabfooter, webheader },
  data () {
    return {
      productInfo: {},
      products: [
        { imgUrl: require('../assets/img/products/2.png'), type: '动画/古墓冒险/悬疑/热血/动作', times: '15-20分钟/集', desc: '首款全引擎流程作品首款全引擎流程作品《地灵曲》由神漫文化核心团队打造， 通过动作捕捉技术结合UE引擎强大的即时渲染能力， 突破性的实现了兼顾品质与效率的制片流程。' },
        { imgUrl: require('../assets/img/products/2.png'), type: '动画/古墓冒险/悬疑/热血/动作', times: '15-20分钟/集', desc: '首款全引擎流程作品首款全引擎流程作品《地灵曲》由神漫文化核心团队打造， 通过动作捕捉技术结合UE引擎强大的即时渲染能力， 突破性的实现了兼顾品质与效率的制片流程。' },
        { imgUrl: require('../assets/img/products/3.png'), type: '动画/古墓冒险/悬疑/热血/动作', times: '15-20分钟/集', desc: '首款全引擎流程作品首款全引擎流程作品《地灵曲》由神漫文化核心团队打造， 通过动作捕捉技术结合UE引擎强大的即时渲染能力， 突破性的实现了兼顾品质与效率的制片流程。' }
      ]
    }
  },
  created () {
    this.productInfo = this.products[0]
  },
  methods: {
    changeProduct (val) {
      this.productInfo = this.products[val]
    }
  }
}
</script>

<style scoped>
.product-info {
  text-align: center;
  width: 100%;
}
.carousel {
  padding-top: 5%;
  width: 100%;
  text-align: center;
}
.products-content {
  height: calc(100% - 145px);
  width: 100%;
  background: url("../assets/img/products/1.png");
  background-size: cover;
}
.product-desc {
  padding-left: 40%;
  margin-top: 40px;
  width: 426px;
  min-height: 120px;
  text-align: center;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 40px;
  color: #dedede;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  opacity: 1;
}
.product-other-info {
  width: 100%;
  text-align: center;
  height: 45px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 30px;
  color: #8b8b8b;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/view/products.vue